/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { TopicOptOut } from './TopicOptOut';
import {
    TopicOptOutFromJSON,
    TopicOptOutFromJSONTyped,
    TopicOptOutToJSON,
} from './TopicOptOut';

/**
 * 
 * @export
 * @interface ListTopicOptOuts200Response
 */
export interface ListTopicOptOuts200Response {
    /**
     * 
     * @type {Array<TopicOptOut>}
     * @memberof ListTopicOptOuts200Response
     */
    data: Array<TopicOptOut>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListTopicOptOuts200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListTopicOptOuts200Response interface.
 */
export function instanceOfListTopicOptOuts200Response(value: object): value is ListTopicOptOuts200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListTopicOptOuts200ResponseFromJSON(json: any): ListTopicOptOuts200Response {
    return ListTopicOptOuts200ResponseFromJSONTyped(json, false);
}

export function ListTopicOptOuts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTopicOptOuts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TopicOptOutFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListTopicOptOuts200ResponseToJSON(value?: ListTopicOptOuts200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(TopicOptOutToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

